import Tag from "@/assets/icons/ProductTag.svg";
import DetailBadge from "@/components/ui/DetailBadge";
import { TProductInfo } from "@/types/projectType";

const ProductDetailsModal = ({
  productInfo,
  orderCurrency,
}: {
  orderCurrency: string;
  productInfo: TProductInfo[];
}) => {
  return (
    <div className="space-y-[11px]">
      {productInfo.map((product, i) => (
        <div className="space-y-[11px]" key={i}>
          <div className="flex items-center gap-x-5">
            <h2 className="text-[20px] font-semibold   leading-[28px]">
              {product.name}
            </h2>
            <p className="px-2.5 flex gap-x-0.5 items-center py-0.5 border border-[#17457D17]  bg-[#f3f3f3] text-gray-600 w-fit font-medium text-[10px] rounded-full ">
              <Tag /> {product?.type}
            </p>
          </div>
          <div className="w-[222px] border-[#BBC0C7] border rounded-[8px] overflow-hidden">
            <img
              className="w-full object-cover"
              src={product?.image?.live_url as string}
              alt=""
            />
          </div>
          {/* <DetailBadge title="Delivery" desc={productInfo.} /> */}
          <DetailBadge title="Description" desc={product.desc} />
          <div className="h-[1px] w-full bg-[#E5E9EB]" />

          <div className="flex justify-between flex-wrap ">
            <DetailBadge
              title="Product Requirement "
              desc={product.requiresModeling ? "Modeling" : ""}
            />
            <DetailBadge
              title="Product Cost "
              desc={`${orderCurrency} ${product.cost}`}
            />
            <DetailBadge
              title="Product Category"
              desc={product.category?.title as string}
            />
            <DetailBadge
              isLink={true}
              title="Product Homepage"
              desc={product?.url as string}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductDetailsModal;
